// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const basculegion_female: PokeData = {
  "id": 10248,
  "name": "basculegion-female",
  "height": 30,
  "weight": 1100,
  "base_experience": 265,
  "types": [
    PokeType.WATER,
    PokeType.GHOST
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "tail-whip",
    "bite",
    "water-gun",
    "flail",
    "scary-face",
    "crunch",
    "shadow-ball",
    "uproar",
    "aqua-jet",
    "head-smash",
    "soak",
    "phantom-force",
    "wave-crash"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "scary-face",
    "crunch",
    "shadow-ball",
    "aqua-jet",
    "phantom-force",
    "soul-sacrifice",
    "liquidation",
    "shadow-dagger",
    "whirlpool",
    "lick"
  ],
  "evolution_chain": {
    "id": 280,
    "item": null,
    "species": [
      {
        "name": "basculin",
        "order": 551,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "basculegion",
        "order": 902,
        "types": [
          PokeType.WATER,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 550,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.RECOIL_DAMAGE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 139,
    "speed": 114,
    "ability_power": 147
  },
  "stat_changes": [],
  "catch_rate": 135,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
